import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	getOrderPerformanceFeatures,
	getOrderPerformanceFeaturesBuildTime,
	resolveOrderViewerCapabilities,
	setOrderPerformanceFeaturesFromApi,
} from '../constants/orderPerformanceFeatureFlags';

const OrderPerformanceFeaturesContext = createContext({
	features: getOrderPerformanceFeaturesBuildTime(),
	viewerCapabilities: resolveOrderViewerCapabilities(null),
});

export const useOrderPerformanceFeatures = () => useContext(OrderPerformanceFeaturesContext).features;

export const useOrderViewerCapabilities = () => useContext(OrderPerformanceFeaturesContext).viewerCapabilities;

const OrderPerformanceFeaturesProvider = ({ children }) => {
	const userInfo = useSelector((state) => state.auth.userInfo);
	const userId = userInfo?._id;
	const [features, setFeatures] = useState(() => getOrderPerformanceFeatures());

	const loadFeatures = useCallback(async () => {
		try {
			const res = await fetch('/api/config/order-performance-features', { credentials: 'include' });
			if (!res.ok) return;
			const data = await res.json();
			setOrderPerformanceFeaturesFromApi(data);
			setFeatures(getOrderPerformanceFeatures());
		} catch {
			// 仅使用构建时配置
		}
	}, []);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			await loadFeatures();
			if (cancelled) return;
		})();
		return () => {
			cancelled = true;
		};
	}, [loadFeatures, userId]);

	const value = useMemo(
		() => ({
			features,
			viewerCapabilities: resolveOrderViewerCapabilities(userInfo),
		}),
		[features, userInfo],
	);

	return <OrderPerformanceFeaturesContext.Provider value={value}>{children}</OrderPerformanceFeaturesContext.Provider>;
};

OrderPerformanceFeaturesProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default OrderPerformanceFeaturesProvider;
